/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentResponseDTO
 */
export interface AttachmentResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof AttachmentResponseDTO
     */
    idAllegato?: number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentResponseDTO
     */
    fileName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentResponseDTO
     */
    dataCreazione?: Date;
}

/**
 * Check if a given object implements the AttachmentResponseDTO interface.
 */
export function instanceOfAttachmentResponseDTO(value: object): value is AttachmentResponseDTO {
    return true;
}

export function AttachmentResponseDTOFromJSON(json: any): AttachmentResponseDTO {
    return AttachmentResponseDTOFromJSONTyped(json, false);
}

export function AttachmentResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idAllegato': json['idAllegato'] == null ? undefined : json['idAllegato'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'dataCreazione': json['dataCreazione'] == null ? undefined : (new Date(json['dataCreazione'])),
    };
}

export function AttachmentResponseDTOToJSON(json: any): AttachmentResponseDTO {
    return AttachmentResponseDTOToJSONTyped(json, false);
}

export function AttachmentResponseDTOToJSONTyped(value?: AttachmentResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idAllegato': value['idAllegato'],
        'fileName': value['fileName'],
        'dataCreazione': value['dataCreazione'] == null ? undefined : ((value['dataCreazione']).toISOString()),
    };
}

